createStaticModel